import { api } from "./api";

interface ApiResponse {
    req: {
        page: string;
        limit: string;
        search: string;
    };
    data: [];
    total: number;
    currentPage: number;
    totalPages: number;
}

export const skillService = {
    async getSkills(req: { page: number; pageSize: number }): Promise<ApiResponse> {
        const response = await api.get('skills', {
            params: {
                page: req.page,
                limit: req.pageSize
            }
        });
        return response.data;
    },

    async createSkill(skill: Omit<any, 'id'>): Promise<any> {
        const response = await api.post('skills', skill);
        return response.data;
    },

    async updateSkill(skill: any): Promise<any> {
        const response = await api.put(`skills/${skill.id}`, skill);
        return response.data;
    },

    async deleteSkill(skillId: string): Promise<void> {
        await api.delete(`skills/${skillId}`);
    }
};